import React, { useEffect, useState } from "react";
import { Btn, Eyebrow } from "../../components/Primitives";
import { api } from "../../lib/api";
import logger from "../../lib/logger";

export default function Briefing({ user, dateId, onBack }) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.dating.briefing(dateId, user.session_id)
            .then(setData)
            .catch(e => logger.error("briefing failed", e))
            .finally(() => setLoading(false));
    }, [dateId, user.session_id]);

    return (
        <div className="flex-1 flex flex-col bg-cream" data-testid="briefing-screen">
            <div className="px-6 pt-6 pb-2 flex items-center justify-between">
                <button data-testid="briefing-back-btn" onClick={onBack} className="tap-target text-[11px] tracking-[0.28em] uppercase text-ink-muted">← Back</button>
                <span className="text-[10px] tracking-[0.32em] uppercase text-ink-muted">Pre-date briefing</span>
            </div>

            <div className="px-7 pt-4 pb-2">
                <Eyebrow>What to know</Eyebrow>
                <h1 className="mt-2 font-display text-3xl text-burgundy leading-[1.15]">
                    Meeting <span className="italic">{data?.partner_first_name || "your match"}.</span>
                </h1>
                {data?.partner_archetype && (
                    <p className="mt-1 text-xs tracking-[0.24em] uppercase text-ink-muted">
                        Archetype: {data.partner_archetype.name}
                    </p>
                )}
            </div>

            <div className="flex-1 px-7 py-5 overflow-y-auto space-y-5">
                {loading && <div className="text-ink-muted text-sm py-10 text-center">Preparing your briefing…</div>}
                {!loading && data?.prompts?.map((p, i) => (
                    <div key={i} className="border-l-2 border-burgundy/40 pl-4" data-testid={`briefing-prompt-${i}`}>
                        <div className="text-[10px] tracking-[0.32em] uppercase text-gold-deep mb-1">Note {i + 1}</div>
                        <p className="text-base text-ink leading-relaxed">{p}</p>
                    </div>
                ))}
            </div>

            <div className="px-6 pb-8 pt-3">
                <Btn data-testid="briefing-done-btn" variant="secondary" onClick={onBack}>I'm ready</Btn>
            </div>
        </div>
    );
}
